import type { GridSortModel } from "@mui/x-data-grid-pro";

/**
 * Renders a grid sort model in the API's `order` syntax: each field name,
 * suffixed with `-` for descending, comma-separated in priority order, or ""
 * for the server's default order. `sortKeys` maps a grid column's field to the
 * name the server sorts by when the two differ.
 *
 * @example
 * sortModelToOrder([{ field: "name", sort: "asc" }]); // "name"
 * sortModelToOrder([{ field: "name", sort: "desc" }]); // "name-"
 * sortModelToOrder([
 *   { field: "name", sort: "asc" },
 *   { field: "date", sort: "desc" },
 * ]); // "name,date-"
 */
export function sortModelToOrder(
  sortModel: GridSortModel | null | undefined,
  sortKeys: ReadonlyMap<string, string> = new Map(),
): string {
  if (!sortModel?.length) {
    return "";
  }

  return sortModel
    .map(({ field, sort }) => {
      const sortKey = sortKeys.get(field) ?? field;
      return sort === "desc" ? `${sortKey}-` : sortKey;
    })
    .join(",");
}
